export const SEGMENT_COLORS = Object.freeze({
  'desktop': { pie: '#0E90A5', line: '#0E90A5', area: 'rgba(14, 144, 165, 0.3)' },
  'tablet': { pie: '#FFD900', line: '#FFD900', area: 'rgba(255, 217, 0, 0.3)' },
  'phone': { pie: '#81BF41', line: '#81BF41', area: 'rgba(129, 191, 65, 0.3)' },
  'new': { pie: '#04A6FF', line: '#04A6FF', area: 'rgba(4, 166, 255, 0.3)' },
  'revisit': { pie: '#004585', line: '#0070D6', area: 'rgba(0, 112, 214, 0.44)' },
  'refer': { pie: '#FF60AC', line: '#FF60AC', area: 'rgba(255, 96, 172, 0.3)' },
  'etc': '#D8D8D8'
})

export const dashboardChartOptions = {
  pieChart: {

  },
  pieChartSeries: {
    type: 'pie',
    label: { show: false },
    radius: [20, 54],
    center: [62, 62]
  },
  lineChart: {
    xAxis: {
      type: 'category',
      boundaryGap: true,
      axisTick: {
        show: true,
        alignWithLabel: true
      },
      axisLabel: {
        color: '#666'
      },
      axisLine: {
        lineStyle: {
          color: '#ccc'
        }
      }
    },
    yAxis: {
      splitNumber: 2,
      nameLocation: 'end',
      nameRotate: 0,
      nameGap: 15,
      nameTextStyle: {
        color: '#666',
        fontSize: 10,
        padding: [0, 35, 0, 0]
      },
      axisLabel: {
        color: '#666'
      }
    },
    legend: { show: false },
    grid: {
      top: 10,
      left: 20,
      right: 15,
      bottom: 0
    },
    tooltip: {
      trigger: 'axis'
    }
  },
  lineChartSeries: {
    type: 'line',
    stack: 'stack-0',
    smooth: true,
    lineStyle: { width: 1 },
    areaStyle: {},
    showSymbol: false
  },
  mapChartSeries: {
    type: 'map',
    mapType: 'world',
    roam: 'move',
    center: [0, 0],
    left: 10,
    right: 10,
    top: 60,
    zoom: 1,
    markPoint: {
      symbolSize: 0
    },
    select: {
      label: {
        show: false
      }
    },
    label: {
      emphasis: {
        show: false
      }
    },
    itemStyle: {
      areaColor: '#ebebeb',
      borderColor: '#ebebeb',
      emphasis: {
        areaColor: '#ebebeb',
        borderColor: '#aaa',
        color: 'transparent'
      }
    }
  },
  color: {
    session: {
      lineBg: ['#0E90A5'],
      lineAreaBg: ['rgba(14, 144, 165, 0.16)']
    },
    pvPerSession: {
      lineBg: ['#0E90A5'],
      lineAreaBg: ['rgba(14, 144, 165, 0.16)']
    },
    intvlPerSession: {
      lineBg: ['#0E90A5'],
      lineAreaBg: ['rgba(14, 144, 165, 0.16)']
    },
    pageview: {
      lineBg: ['#444'],
      lineAreaBg: ['rgba(0, 0, 0, 0.16)']
    },
    device: {
      pieBg: [SEGMENT_COLORS.desktop.pie, SEGMENT_COLORS.tablet.pie, SEGMENT_COLORS.phone.pie],
      lineBg: [SEGMENT_COLORS.desktop.line, SEGMENT_COLORS.tablet.line, SEGMENT_COLORS.phone.line],
      lineAreaBg: [
        SEGMENT_COLORS.desktop.area,
        SEGMENT_COLORS.tablet.area,
        SEGMENT_COLORS.phone.area
      ]
    },
    exist: {
      pieBg: [SEGMENT_COLORS.new.pie, SEGMENT_COLORS.revisit.pie],
      lineBg: [SEGMENT_COLORS.new.line, SEGMENT_COLORS.revisit.line],
      lineAreaBg: [SEGMENT_COLORS.new.area, SEGMENT_COLORS.revisit.area]
    },
    refer: {
      pieBg: ['#04A6FF', '#004585', '#FFD900', '#9ACC67', '#B493EA', '#D8D8D8'],
      lineBg: ['#04A6FF', '#0070D6', '#FFBF00', '#81BF41', '#B493EA', '#666'],
      lineAreaBg: [
        'rgba(4, 166, 255, 0.3)',
        'rgba(0, 112, 214, 0.44)',
        'rgba(255, 217, 0, 0.3)',
        'rgba(154, 204, 103, 0.3)',
        'rgba(180, 147, 234, 0.3)',
        'rgba(170, 170, 170, 0.3)'
      ]
    }
  }
}
